import CancelIcon from "@mui/icons-material/Cancel";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "./style.css";

const green = {
  50: "#74b44a",
  100: "#74b44a",
  200: "#74b44a",
  300: "#74b44a",
  400: "#74b44a",
  500: "#74b44a",
  600: "#74b44a",
  700: "#74b44a",
  800: "#74b44a",
  900: "#74b44a",
  A100: "#74b44a",
  A200: "#74b44a",
  A400: "#74b44a",
  A700: "#74b44a",
};

const defaultMaterialTheme = createTheme({
  palette: {
    primary: green,
  },
});

export default function DateRangeFilter({ dateRange, setDateRange }) {
  const [dateFilterClass, setDateFilterClass] = useState(
    "filter-container-hidden"
  );

  const escFunction = (event) => {
    if (event.keyCode === 27) {
      setDateFilterClass("filter-container-hidden");
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => document.removeEventListener("keydown", escFunction, false);
  }, []);

  const startValue = dateRange.startDate ? dayjs(dateRange.startDate) : null;
  const endValue = dateRange.endDate ? dayjs(dateRange.endDate) : null;

  const handleStartChange = (value) => {
    const nextStart = value ? value.toDate() : null;
    setDateRange((s) => {
      const end = s.endDate;
      const shouldClearEnd =
        nextStart && end && dayjs(end).isBefore(dayjs(nextStart), "day");
      return {
        ...s,
        startDate: nextStart,
        endDate: shouldClearEnd ? null : end,
        key: "selection",
      };
    });
  };

  const handleEndChange = (value) => {
    setDateRange((s) => ({
      ...s,
      endDate: value ? value.toDate() : null,
      key: "selection",
    }));
  };

  return (
    <div className="position-relative ml-3">
      <div className="d-flex align-items-center">
        <button
          id="add-lab-button"
          onClick={() =>
            setDateFilterClass((s) =>
              s === "filter-container-visible"
                ? "filter-container-hidden"
                : "filter-container-visible"
            )
          }
          className="btn btn-primary ml-auto"
        >
          Date Range <CalendarTodayIcon fontSize="small" />
        </button>
        {dateRange.startDate !== null && (
          <CloseIcon
            className="clear-filter"
            data-tip="clear"
            onClick={() =>
              setDateRange({
                startDate: null,
                endDate: null,
                key: "selection",
              })
            }
          />
        )}
      </div>
      <div className={dateFilterClass}>
        <CancelIcon
          className="close-filter"
          style={{ fontSize: "18px" }}
          onClick={() => setDateFilterClass("filter-container-hidden")}
        />
        <ThemeProvider theme={defaultMaterialTheme}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div className="date-range-pickers shadow">
              <div className="date-range-picker-col">
                <div className="date-range-picker-label">Start</div>
                <StaticDatePicker
                  value={startValue}
                  onChange={handleStartChange}
                  slotProps={{
                    actionBar: { actions: [] },
                    toolbar: { hidden: true },
                  }}
                />
              </div>
              <div className="date-range-picker-col">
                <div className="date-range-picker-label">End</div>
                <StaticDatePicker
                  value={endValue}
                  minDate={startValue || undefined}
                  onChange={handleEndChange}
                  slotProps={{
                    actionBar: { actions: [] },
                    toolbar: { hidden: true },
                  }}
                />
              </div>
            </div>
          </LocalizationProvider>
        </ThemeProvider>
      </div>
    </div>
  );
}
